// extracted by mini-css-extract-plugin
module.exports = {"services":"services-module--services--1C5Uv","row":"services-module--row--3liL6","service":"services-module--service--27MmZ"};